import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { GruposPageModule } from '../pages/grupos/grupos.module';
import { HttpServiceProvider } from '../providers/http-service/http-service';
import { HttpClientModule } from '@angular/common/http';
import { AlertProvider } from '../providers/alert/alert';
import { CartService } from '../pages/cart.service';
import { ToastProvider } from '../providers/toast/toast';
import { CurrencyPipe } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { File } from '@ionic-native/file'
import { IonicSelectableModule } from 'ionic-selectable';

registerLocaleData(localePtBr);

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrMaskerModule,
    BrowserModule,
    GruposPageModule,
    HttpClientModule,
    IonicSelectableModule,
    IonicModule.forRoot(MyApp, {
      scrollPadding: false,
      scrollAssist: true,
      autoFocusAssist: false
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    {
      provide: LOCALE_ID,
      useValue: "pt-BR"
    },
    CurrencyPipe,
    HttpServiceProvider,
    AlertProvider,
    CartService,
    ToastProvider,
    File
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts